module.exports = __webpack_public_path__ + "img/max-envelope-deny.cadfc9d3.svg";